import CONFIG from '../constants/CONFIG';
import lockBodyScroll from './lockBodyScroll';

/**
 * This function handles removing the consent banner for the DOM
 */
const removeConsentBanner = () => {
  const banner = document.querySelector('.gdpr-consent-banner');

  if (!banner) {
    return false;
  }

  banner.classList.add('gdpr-consent-banner--fade-out');

  lockBodyScroll(false);

  setTimeout(() => {
    document.body.removeChild(banner);
  }, CONFIG.BANNER_REMOVAL_DELAY);

  return true;
};

export default removeConsentBanner;
